import { useState, useContext } from 'react'
import { Context } from '../../../context/Provider'
import { convertToNumber } from '../../../utilities/convertToNumber'

import { SelectedDisclosureMethod, FloaterValuesError } from '../../../components/SharedComponents'
import { Space, theme, Input, Text, MainContainer, Divider, Alert } from 'verak-ui'

const Floater = ({ handleSave }) => {
	const [state, dispatch] = useContext(Context)
	const [MaxValueAllLoc, setMaxValueAllLoc] = useState(
		state.quote?.DeclarationQ?.MaxValueAllLoc || ''
	)
	const [MaxValueOneLoc, setMaxValueOneLoc] = useState(
		state.quote?.DeclarationQ?.MaxValueOneLoc || ''
	)
	const [error, setError] = useState(false)

	const checkForValues = () => {
		if (MaxValueAllLoc) {
			return false
		} else {
			return true
		}
	}
	const disableProceed = checkForValues()

	const proceed = async () => {
		if (parseFloat(MaxValueOneLoc) > parseFloat(MaxValueAllLoc)) {
			setError(true)
		} else {
			handleSave(MaxValueAllLoc, MaxValueOneLoc)
		}
	}

	const handleChangeInMaxValueAllLoc = e => {
		const numValue = convertToNumber(e.target.value)
		setMaxValueAllLoc(numValue)
	}
	const handleChangeInMaxValueOneLoc = e => {
		const numValue = convertToNumber(e.target.value)
		setMaxValueOneLoc(numValue)
	}

	let renderStocSumInsAlert = null

	if (parseInt(MaxValueAllLoc) > 500000000) {
		renderStocSumInsAlert = (
			<>
				<Space y={1} />
				<Alert
					bgColor={theme.colors.secondaryLightRed}
					iconName="warningTriangleSm"
					infoIconColor={theme.colors.red}
					titleColor={theme.colors.red}
					title="Important Notice"
				>
					<Space y={0.5} />
					<Text type="body2" style={{ marginLeft: '2rem' }}>
						The Sum Insured has exceeded ₹50 crore - you may continue with the quotation. However,
						you will not get an immediate quote - the Sales Manager will need to help you.
					</Text>
				</Alert>
			</>
		)
	}

	return (
		<MainContainer
			header="Stock details"
			top={2.5}
			rightOnClick={proceed}
			rightDisabled={disableProceed}
		>
			<SelectedDisclosureMethod method="Floater Basis" />
			<Input
				label="Total value of stock:"
				labelStyle={textStyle}
				placeholder="Enter value here"
				value={MaxValueAllLoc}
				onChange={e => handleChangeInMaxValueAllLoc(e)}
				compulsory
				autoComma
				rupee
			/>
			<Space y={2.5} />
			<Alert
				variant="secondary"
				infoIconColor={theme.colors.secondary}
				titleColor={theme.colors.secondary}
				title="Please enter the maximum value for your stock (from the previous year) for each stock
				location and add it together"
			/>
			<Divider top={2.5} bottom={2.5} />
			<Input
				label="Maximum stock value at any one location:"
				labelStyle={textStyle}
				placeholder="Enter value here"
				value={MaxValueOneLoc}
				onChange={e => handleChangeInMaxValueOneLoc(e)}
				autoComma
				rupee
			/>

			{error ? (
				<>
					<Space y={1.5} />
					<FloaterValuesError />
				</>
			) : null}
			{renderStocSumInsAlert}
		</MainContainer>
	)
}

export default Floater

const textStyle = {
	fontSize: '24px',
	fontWeight: 700,
	color: `${theme.colors.gray7}`,
	marginBottom: '1rem',
}
